import React from 'react';
import ReportingDonationsYearEndSummaryPage from '../components/ReportingDonationsYearEndSummaryPage';

const ReportingDonationsYearEndSummaryApp = (props) => (
  <ReportingDonationsYearEndSummaryPage {...props} />
);

export default ReportingDonationsYearEndSummaryApp;
